import React from 'react'

const BonusAndDeductionRules = () => {
    return (
        <>BonusAndDeductionRules mobile</>
    )
}

export { BonusAndDeductionRules }